import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {colorFunctions} from "../../constants/colors";
import {useHistory} from 'react-router-dom';
import backgroundImage from "../../../images/nationwidebackground.png";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import AmChartDoughnutIndicator from "../../components/AmChartDoughnutIndicator";
import AmChartSimpleBar from "../../components/AmChartSimpleBar";
import AmChartSimpleColumn from "../../components/AmChartSimpleColumn";
import AmChartSimpleLine from "../../components/AmChartSimpleLine";
import {useParams} from "react-router-dom";
import {JWT} from "../../constants/local-storage";
import DashboardSelector from "../../components/DashboardSelector";
import DashboardPhotoNavigator from "../../components/DashboardPhotoNavigator";
import UtilisationChartBar from "../utilisation/components/UtilisationChartBar";
import UtilisationChartBarBreakdownWorkstation from "../utilisation/components/UtilisationChartBarBreakdownWorkstation";

export default function UtilisationWorkstations(){
	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const history = useHistory();
	
	const refFacility = useRef(null);
	
	const [utilisationAvg, setUtilisationAvg] = useState(0);
	const [utilisationMax, setUtilisationMax] = useState(0);
	const [utilisationMin, setUtilisationMin] = useState(0);
	const [utilisationEfficiency, setUtilisationEfficiency] = useState(0);
	const [seats, setSeats] = useState(0);
	const [observations, setObservations] = useState(0);
	const [datePeak, setDatePeak] = useState("");
	const [dateMin, setDateMin] = useState("");
	const [dataByFacility, setDataByFacility] = useState([]);
	const [dataByGroup, setDataByGroup] = useState([]);
	const [dataByHour, setDataByHour] = useState([]);
	const [dataUtilisationByDate, setDataUtilisationByDate] = useState([]);
	const [dataUtilisationEfficiencyByDate, setDataUtilisationEfficiencyByDate] = useState([]);
	const [dataByFloor, setDataByFloor] = useState([]);
	const [dataBySpace, setDataBySpace] = useState([]);
	const [leftBarChartData, setLeftBarChartData] = useState([]);
	const [loaded, setLoaded] = useState(false);
	
	
	const [facilityId, setFacilityId] = useState("-100");
	const [floorId, setFloorId] = useState("-100");
	const [spaceId, setSpaceId] = useState("-100");
	const [spaceTypeId, setSpaceTypeId] = useState("-100");
	const [classificationId, setClassificationId] = useState("1");
	const [classificationItemId, setClassificationItemId] = useState("-100");
	
	const [leftBarChartHeight, setLeftBarChartHeight] = useState("100px");
	
	const [displayRoomTable, setDisplayRoomTable] = useState("none");
	const [displayGroupChart, setDisplayGroupChart] = useState("flex");
	
	const [facility, setFacility] = useState({});
	
	const groupTypes = [
		{code:"GROUP_TYPE_CLASS_CR", name: "CR Class", urlExtension:"crclass"},
		{code:"GROUP_TYPE_SPACE_TYPE", name:"Space Type", urlExtension:"spacetype"}
	];
	const [groupType, setGroupType] = useState(groupTypes[0].code);
	
	
	

	
	
	
	const getQueryAppend = () => {
		return "?facilityId=" + facilityId + 
				"&floorId=" + floorId + 
				"&spaceId=" + spaceId + 
				"&spaceTypeId=" + spaceTypeId + 
				"&classificationId=" + classificationId + 
				"&classificationItemId=" + classificationItemId;
	}
	
	const facilityIdParam = useParams()["facilityId"];
	
	useEffect(() => {
		
		if(loaded === false){
			setFacilityId(facilityIdParam);
			const timer = setTimeout(() => {
				refFacility.current.value = facilityIdParam;		
			}, 4000);
			
			
			setLoaded(true);
		}
		
		
		
		let queryAppend = getQueryAppend();
				
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetaverage" + queryAppend, null, populateUtilisationAvg);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetmax" + queryAppend, null, populateUtilisationMax);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetmin" + queryAppend, null, populateUtilisationMin);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetefficiency" + queryAppend, null, populateUtilisationEfficiency);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetcapacity" + queryAppend, null, populateSeats);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetobservations" + queryAppend, null, populateObservations);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetdatemax" + queryAppend, null, calculateDatePeak);
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetdatemin" + queryAppend, null, calculateDateMin);
		//functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyfacility" + queryAppend, null, populateDataByFacility);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyclassificationitem" + queryAppend, null, populateDataByClassificationItem);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyhour" + queryAppend, null, populateDataByHour);
		functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetbydate" + queryAppend, null, populateDataUtilisationByDate);
		//functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetspacetypes" + queryAppend, null, populateSpaceTypes);
		//functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetclassificationitems" + queryAppend, setClassificationItems, null);
		
		
		
		if(spaceId != "-100"){
			setDisplayRoomTable("flex");
			setDisplayGroupChart("none");
		}
		else{
			setDisplayRoomTable("none");
			setDisplayGroupChart("flex");
		}
	
		if(facilityId === '-100'){
			functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyfacility" + queryAppend, null, populateDataByFacility);
		}
		else{
			if(floorId === "-100"){
				functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyfloor" + queryAppend, null, populateDataByFloor);
			}
			else{
				if(spaceId === "-100"){
					functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyspace" + queryAppend, null, populateDataBySpace);
				}
			}
		}
		
		
	
		
	}, [facilityId, floorId, spaceId, spaceTypeId, classificationId, classificationItemId]);
	
	
	useEffect(() => {	
		let queryAppend = getQueryAppend();
				
		functions.getObjectFromAjax("/resolutionsoftwareplatform/utilisationgetefficiencyovertime" + queryAppend, null, populateUtilisationEfficiencyOverTime);
		
	}, [dataUtilisationByDate]);
	
	
	useEffect(() => {
			
			let queryAppend = getQueryAppend();
				
			let urlExtension = "";
			for(let i=0; i<groupTypes.length; i++){
				if(groupTypes[i].code === groupType){
					urlExtension = groupTypes[i].urlExtension;
				}	
			}
			if(groupType === "GROUP_TYPE_CLASS_CR"){
				functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyclassificationitem" + queryAppend, null, populateDataByClassificationItem);
			}
			else{
				functions.getArrayFromAjax("/resolutionsoftwareplatform/utilisationgetavgbyspacetype" + queryAppend, null, populateDataBySpaceType);
			}
		
	}, [groupType]);
	
	useEffect(() => {
		setLeftBarChartHeight((20*leftBarChartData.length + 100) + 'px');
	}, [leftBarChartData]);

	
	const populateSeats = (obj) => {
		setSeats(obj.returnDouble);
	};
	
	const populateObservations = (obj) => {
		setObservations(obj.returnDouble);
	};
	
	const populateUtilisationMax = (obj) => {
		let thisValue = obj.returnDouble;
		if(parseInt(thisValue) > 100){
			setUtilisationMax(100);
		}
		else{
			setUtilisationMax(obj.returnDouble);
		}
	};
	
	const populateUtilisationMin = (obj) => {
		setUtilisationMin(obj.returnDouble);
	};
	
	const populateUtilisationEfficiency = (obj) => {
		setUtilisationEfficiency(obj.returnDouble);
	};
	
	const populateUtilisationAvg = (obj) => {
		setUtilisationAvg(obj.returnDouble);
	};
	
	
	
	const calculateDatePeak = (input) => {
		
		setDatePeak(input.returnDate);
	};
	
	const calculateDateMin = (input) => {
		setDateMin(input.returnDate);
	};
	
	const populateSpaceTypes = (results) => {
		let tempSpaceTypes = [];
		for(let i=0; i<results.length; i++){
			tempSpaceTypes.push({
				id:results[i].id,
				name:results[i].code + ': ' + results[i].name
			});
		}
		//setSpaceTypes(tempSpaceTypes);
	};
	
	const populateDataByFacility = (results) => {
		let tempDataByFacility = [];
		for(let i=0; i<results.length; i++){
			tempDataByFacility.push({
				id:results[i].id,
				label:results[i].name,
				value:results[i].avg
			});
		}
		setLeftBarChartData(tempDataByFacility);
		setDataByFacility(tempDataByFacility);
	};
	
	const populateDataByFloor = (results) => {
		let tempDataByFloor = [];
		for(let i=0; i<results.length; i++){
			tempDataByFloor.push({
				id:results[i].id,
				label:results[i].name,
				value:results[i].avg
			});
		}
		setLeftBarChartData(tempDataByFloor);
		setDataByFloor(tempDataByFloor);
	};
	
	const populateDataBySpace = (results) => {
		
		let tempDataBySpace = [];
		for(let i=0; i<results.length; i++){
			tempDataBySpace.push({
				id:results[i].id,
				label:(results[i].code + ': ' + results[i].name),
				value:results[i].avg
			});
		}
		setLeftBarChartData(tempDataBySpace);
		setDataBySpace(tempDataBySpace);
	};
	
	const populateDataByClassificationItem = (results) => {
		
		let tempDataByGroup = [];
		for(let i=0; i<results.length; i++){
			let labelString = results[i].name;
			if(labelString.length > 20){
				labelString = labelString.substring(0, 20) + '...';
			}
			tempDataByGroup.push({
				id:results[i].id,
				label:labelString,
				value:results[i].avg
			});
		}
		setDataByGroup(tempDataByGroup);
	};
	
	const populateDataBySpaceType = (results) => {
		let tempDataByGroup = [];
		for(let i=0; i<results.length; i++){
			let labelString = results[i].code + ": " + results[i].name;
			if(labelString.length > 20){
				labelString = labelString.substring(0, 20) + '...';
			}
			tempDataByGroup.push({
				id:results[i].id,
				label:labelString,
				value:results[i].avg
			});
		}
		setDataByGroup(tempDataByGroup);
	};
	
	const populateDataByHour = (results) => {
		let tempDataByHour = [];
		for(let i=0; i<results.length; i++){
			tempDataByHour.push({
				id:results[i].label,
				label:results[i].label,
				value:results[i].avg
			});
		}
		setDataByHour(tempDataByHour);
	};
	
	const populateDataUtilisationByDate = (results) => {
		
		let queryAppend = getQueryAppend();
				
		let tempDataUtilisationByDate = [];
		for(let i=0; i<results.length; i++){
			tempDataUtilisationByDate.push({
				id:results[i].label,
				label:results[i].label,
				utilisation:parseInt(results[i].avg)
			});
		}
		setDataUtilisationByDate(tempDataUtilisationByDate);
		
	
	};
	
	const populateUtilisationEfficiencyOverTime = (results) => {
		let tempDataUtilisationEfficiencyByDate = [];
		for(let i=0; i<results.length; i++){
			tempDataUtilisationEfficiencyByDate.push({
				label:results[i].groupBy,
				efficiency:results[i].returnDouble,
				utilisation:dataUtilisationByDate[i].utilisation
			})
		}
		setDataUtilisationEfficiencyByDate(tempDataUtilisationEfficiencyByDate);
	};
	
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	minheight:"100vh",
  	left:"0px",
  	top:"0px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"60px",
  	left:"60px",
  	bottom:"0px",
  	right:"0px",
  	flexDirection:"column",
  	overflow:"auto"
  };
 
 	const topContainer ={
 		display:"flex",
 		height:"calc(100vh - 0px)",
 		width:"100%"
 	};
 	
 	const leftContainer ={
 		display:"flex",
 		flexDirection:"column",
 		width:"520px",
 		marginRight:"0px",
 		//borderRight:"2px solid #eee",
 		paddingTop:"0px",
 		backgroundColor:"#fff",
 		minHeight:"200vh",
 	};
 	
 	const rightContainer ={
 		display:"flex",
 		flexDirection:"column",
 		width:"calc(100% - 542px)"
 	};
 	
 	const rightTopContainer ={
 		display:"flex",
 		width:"100%",
 		height:"200px",
 		justifyContent:"space-between",
 	};
 	
 	const kpiContainer = {
 		display:"flex",
 		height:"100%",
 		width:"100%",
 		justifyContent:"space-around",
 		flexWrap:"wrap"
 	};
 	
 	const kpiDougnutContainer = {
 		display:"flex",
 		width:"20%",
 		height:"calc(100% - 40px)"	,
 		flexDirection:"column",
 		paddingTop:"20px"
 	};
 	
 	const kpiDoughnutTitle = {
 		display:"flex",
 		height:"10px",
 		width:"100%",
 		alignItems:"center",
 		justifyContent:"space-around",
 		fontSize:"14px",
 		fontWeight:"bold"
 	};
 	
 	const rightBottomContainer ={
 		display:"flex",
 		height:"calc(100vh - 300px)",
 		width:"calc(100% + 100px)",
 		marginTop:"20px"
 	};
 	
 	const rightBottomLeftContainer ={
 		display:"flex",
 		width:"60%",
 		height:"calc(100vh - 200px)",
 		flexDirection:"column"
 	};
 	
 	const rightBottomLeftTitle = {
 		display:"flex",
 		height:'30px',
 		color:"white",
 		justifyContent:"space-around",
		alignItems:"center"
 	};
 	
 	const rightBottomRightContainer ={
 		display:"flex",
 		width:"40%",
 		height:"calc(100% - 4px)",
 		flexDirection:"column"
 	};
 	
 	const bottomContainer ={
 		display:"flex",
 		width:"100%",
 		height:"calc(100vh - 560px)",
 		flexDirection:"column",
 		minHeight:"300px"
 	}; 
 	
 	const clickFacility = (id) => {
 		refFacility.current.value = id;
 		setFacilityId(id);
 	};
 	
 	const clickSpace= (id) => {
 		
 		//refSpace.current.value = id;
 		setSpaceId(id);
 	};
 	
 	const clickFloor = (id) => {
 		//refFloor.current.value = id;
 		setFloorId(id);
 	};
 	
 	const dataByDateGraphs = [
 		{id:"utilisation", title:"Average Utilisation", keyColumn:"utilisation", color:"blue"},
 		{id:"efficiency", title:"Efficiency", keyColumn:"efficiency", color:"green"},
 	];
 	
 	const selectPanel = {
 		display:"flex",
 		height:"40px",
 		alignItems:"center",
 		marginLeft:"20px"
 	};
 	
 	const selectPanelLabel = {
 		display:'flex',
 		width:"140px",
 		color:"black",
 		fontSize:'12px',
 		fontWeight:"bold"
 	};
 	
 	const selectPanelSelect = {
 		display:'flex',
 		width:"200px",
 		height:"30px",
 		border:"1px solid lightgrey",
 		borderRadius:"5px",
 		paddingLeft:"10px",
 		fontSize:'12px'
 	};
 	
 
 	
 	const switchGrouping = (e) => {
 		setGroupType(e.target.value);
 	};
 	
 	const goSite = () => {
 		setFacilityId("-100");
 		setFloorId("-100");
 		setSpaceId("-100");
 	};
 	
 
 	const handleChangeFacility = (e) => {
 		setFacilityId(e.target.value);
 		if(e.target.value === "-100"){
 			setSpaceId("-100");
 			setFloorId("-100");
 		}
 	};
 	
 	const handleChangeFloor = (e) => {
 		setFloorId(e.target.value);
 		if(e.target.value === "-100"){
 			setSpaceId("-100");
 		}
 	};
 	
 	const handleChangeSpace = (e) => {
 		setSpaceId(e.target.value);
 	};
 	
 	const roomTableContainer = {
 		display:displayRoomTable,
 		width:"calc(100% - 40px)",
 		margin:"20px",
 		marginBottom:"100px",
 		minHeight:"600px"
 	};
 	
 	const roomInfoContainer = {
 		display:displayRoomTable,
 		width:"100%"
 	};
 	
 	const groupChartContainer ={
 		display:displayGroupChart,
 		width:"100%",
 		flexDirection:"column",
 		paddingTop:"10px",
 		height:"calc(100% - 20px)"
 	};
 	
 	const barChartContainer = {
 		display:'flex',
 		width:"100%",
 		marginTop:"20px",
 		minHeight:"200px"
 	};
 	
 	const handleBarClick = (id) => {
	 		if(facilityId === "-100"){
	 			clickFacility(id);
	 		}
	 		else{
	 			if(floorId === "-100"){
	 				clickFloor(id);
	 			}
	 			else{
	 				clickSpace(id);
	 			}
	 		}
 	};
 	
 		const groupTypeOptionDisplay = groupTypes.map((item, index) =>
 		<option value={item.code} style={{color:'black'}}>
 			{item.name}
 		</option>
 	);
 	
	return (
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>	
				<DashboardSelector
					title="Utilisation: Workstations"
				/>
				<div style={mainContainer}>
					<div style={topContainer}>
						<div style={leftContainer}>
							
								<DashboardPhotoNavigator
									refFacility={refFacility}
									facilityId={facilityId}
									setFacilityId={setFacilityId}
									floorId={floorId}
									setFloorId={setFloorId}
									spaceId={spaceId}
									setSpaceId={setSpaceId} 
									classificationId={classificationId}
									setClassificationId={setClassificationId}
									classificationItemId={classificationItemId}
									setClassificationItemId={setClassificationItemId}
									spaceTypeId={spaceTypeId}
									setSpaceTypeId={setSpaceTypeId}
								/>
								<div style={barChartContainer}>
								 <AmChartSimpleBar
								 	chartId="utilisationallleftbar"
								 	chartData={leftBarChartData}
								 	categoryKey="label"
								 	valueKey="value"
								 	width="100%"
								 	height={leftBarChartHeight}
									onClick={handleBarClick}
									/>
								</div>
						</div>
						<div style={rightContainer}>
							<div style={rightTopContainer}>
									<div style={kpiContainer}>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationalldoughnutavgworkstation"
												percentage={utilisationAvg}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Avg Utilisation
											</div>
										</div>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationalldoughnutsolworkstation"
												percentage={utilisationAvg}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Signs Of Life
											</div>
										</div>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationalldoughnutvacanworkstation"
												percentage={utilisationAvg}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Vacant
											</div>
										</div>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationalldoughnutminworkstation"
												percentage={utilisationMax}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Max Utilisation
											</div>
										</div>
										<div style={kpiDougnutContainer}>
											<AmChartDoughnutIndicator
												id="utilisationalldoughnutmaxworkstation"
												percentage={utilisationEfficiency}
												width="120"
												height="120"
											/>
											<div style={kpiDoughnutTitle}>
												Efficiency
											</div>
										</div>
										
									</div>
								
							</div>
							<div style={rightBottomContainer}>
								<div style={rightBottomLeftContainer}>
									<UtilisationChartBar/>
								</div>
								<div style={rightBottomRightContainer}>
									<UtilisationChartBarBreakdownWorkstation/>	
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
	);
}